export enum EEmployerStatus {
    Active = 1,
    CloseForNewMembers = 2,
    FailedLaunch = 3,
    Onboarding = 4,
    ProgramDevelopment = 5,
    Survey = 6
}
